// Migrated to Polaris Web Components
import React, { use, useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { environment } from '../Services/environment';
import { getMappedTemplates } from '../Services/CommonServices';
import Presets from './Presets';
import cronstrue from 'cronstrue';
import axios from 'axios';
import { getNextRun, timezoneOptions } from './TimezoneOptions';
const endpoint = environment.serverUrl;

export default function CronSchedulerConfig({ xmlUrl, setUrlError, storeUrl, setExistingXmlConfig, action, setXmlConfigAction, jobId, setJobId, importType, ftpConfig, setFtpConfig, setSchedulerSelectedTab, integrationConfig, setIntegrationConfig, setCompletedSteps }) {
  const [cronExpression, setCronExpression] = useState('');
  const [selectedPreset, setSelectedPreset] = useState('');
  const [popoverActive, setPopoverActive] = useState(false);
  const [jobName, setJobName] = useState('');
  // const [integrationConfig, setIntegrationConfig] = useState({
  //       jobName: '',
  //       cronExpression: '',
  //       xmlUrl: '',
  //       ftpConfig: null,
  //       templateId: null,
  //       ImportFormat: importType
  //   });
  const togglePopover = useCallback(() => setPopoverActive((active) => !active), []);
  const handleCronChange = (value) => {
    setCronExpression(value.trim().replace(/\s+/g, ' '));
    updateIntegrationField('cronExpression', value.trim().replace(/\s+/g, ' '));
    setSelectedPreset('');
  };
  const [errorHost, setErrorHost] = useState(false);
  const [errorName, setErrorName] = useState(false);
  const [ftpConnection, setFTPConnection] = useState(null);
  const [httpConnection, setHttpConnection] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [testLoading, setTestLoading] = useState(false);
  const handlePresetChange = (value) => {
    setSelectedPreset(value);
    setCronExpression(value);
    updateIntegrationField('cronExpression', value.trim().replace(/\s+/g, ' '));
    setPopoverActive(false);
  };

  const scheduleOptions = [
    { label: "Daily", value: "daily" },
    { label: "Weekdays", value: "weekdays" },
    { label: "Weekends", value: "weekends" },
    { label: "Monday", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
    { label: "Mon - Saturday", value: "mon-sat" },
    { label: "Sun - Thursday", value: "sun-thu" },
    { label: "Tues - Saturday", value: "tue-sat" },
    { label: "Wed - Saturday", value: "wed-sat" },
    { label: "Wed - Sunday", value: "wed-sun" },
    { label: "Sun - Friday", value: "sun-fri" }
  ];

  const hours = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const [selectedSchedule, setSelectedSchedule] = useState("");
  const [selectedHour, setSelectedHour] = useState("00");
  const [selectedMinute, setSelectedMinute] = useState("00");
  const [cronPreset, setCronPreset] = useState(integrationConfig.cronExpression || '');
  const [selectedTimeZone, setSelectedTimeZone] = useState(integrationConfig.timeZone || timezoneOptions[0]?.value || "UTC");
  
  // Generate unique modal ID based on importType
  const modalId = `cron-edit-modal-${importType?.toLowerCase() || 'default'}`;
  
  // Control modal show/hide
  useEffect(() => {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    if (popoverActive) {
      modal.showOverlay();
    } else {
      modal.hideOverlay();
    }
  }, [popoverActive, modalId]);

  // Handle modal hide event
  useEffect(() => {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    const handleHide = () => {
      setPopoverActive(false);
    };

    modal.addEventListener('hide', handleHide);
    return () => modal.removeEventListener('hide', handleHide);
  }, [modalId]);

  useEffect(() => {
    if (!selectedSchedule || selectedHour === "" || selectedMinute === "") return;

    let cron = "";

    switch (selectedSchedule) {
      case "daily":
        cron = `${selectedMinute} ${selectedHour} * * *`;
        break;
      case "weekdays":
        cron = `${selectedMinute} ${selectedHour} * * 1-5`;
        break;
      case "weekends":
        cron = `${selectedMinute} ${selectedHour} * * 6,0`;
        break;
      case "monday":
        cron = `${selectedMinute} ${selectedHour} * * 1`;
        break;
      case "tuesday":
        cron = `${selectedMinute} ${selectedHour} * * 2`;
        break;
      case "wednesday":
        cron = `${selectedMinute} ${selectedHour} * * 3`;
        break;
      case "thursday":
        cron = `${selectedMinute} ${selectedHour} * * 4`;
        break;
      case "friday":
        cron = `${selectedMinute} ${selectedHour} * * 5`;
        break;
      case "saturday":
        cron = `${selectedMinute} ${selectedHour} * * 6`;
        break;
      case "sunday":
        cron = `${selectedMinute} ${selectedHour} * * 0`;
        break;
      case "mon-sat":
        cron = `${selectedMinute} ${selectedHour} * * 1-6`;
        break;
      case "sun-thu":
        cron = `${selectedMinute} ${selectedHour} * * 0-4`;
        break;
      case "tue-sat":
        cron = `${selectedMinute} ${selectedHour} * * 2-6`;
        break;
      case "wed-sat":
        cron = `${selectedMinute} ${selectedHour} * * 3-6`;
        break;
      case "wed-sun":
        cron = `${selectedMinute} ${selectedHour} * * 3,0`;
        break;
      case "sun-fri":
        cron = `${selectedMinute} ${selectedHour} * * 0-5`;
        break;
    }

    // setIntegrationConfig((prev) => ({ ...prev, cronExpression: cron }));
    setCronPreset(cron);
  }, [selectedSchedule, selectedHour, selectedMinute]);

  function parseCronExpression(cron) {
    if (!cron) return { schedule: "", hour: "", minute: "" };

    const parts = cron.trim().split(" ");
    if (parts.length !== 5) return { schedule: "", hour: "", minute: "" };

    const [minute, hour, , , dayOfWeek] = parts;

    let schedule = "";

    switch (dayOfWeek) {
      case "*":
        schedule = "daily";
        break;
      case "1-5":
        schedule = "weekdays";
        break;
      case "6,0":
        schedule = "weekends";
        break;
      case "1":
        schedule = "monday";
        break;
      case "2":
        schedule = "tuesday";
        break;
      case "3":
        schedule = "wednesday";
        break;
      case "4":
        schedule = "thursday";
        break;
      case "5":
        schedule = "friday";
        break;
      case "6":
        schedule = "saturday";
        break;
      case "0":
        schedule = "sunday";
        break;
      case "1-6":
        schedule = "mon-sat";
        break;
      case "0-4":
        schedule = "sun-thu";
        break;
      case "2-6":
        schedule = "tue-sat";
        break;
      case "3-6":
        schedule = "wed-sat";
        break;
      case "3,0":
        schedule = "wed-sun";
        break;
      case "0-5":
        schedule = "sun-fri";
        break;
      default:
        schedule = "";
    }

    setSelectedSchedule(schedule);
    setSelectedHour(hour.padStart(2, "0"));
    setSelectedMinute(minute.padStart(2, "0"));
  }


  const intialIntegrationForm = {
    jobName: '',
    cronExpression: '00 00 * * *',
    xmlUrl: '',
    ftpConfig: null,
    templateId: null,
    ImportFormat: importType
  }
  const [editedXmlUrl, setEditedXmlUrl] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [selectedFtpConfig, setSelectedFtpConfig] = useState();
  // const [FtpConfigs , setFtpConfigs] = useState([]);
  // const [existingTemplates, setExistingTemplates] = useState([]);
  const [selectedTemplateID, setSelectedTemplateID] = useState();
  const [selectedTemplate, setSelectedTemplate] = useState();
  // const [templateOptions, setTemplateOptions] = useState([]);
  // const [FtpConfigOptions, setFtpConfigOptions] = useState([]);
  //  const handleTemplateChange = useCallback((value) => setSelectedTemplateID(value), []);
  // const handleFtpConfigChange = useCallback((value) => setSelectedFtpConfig(value), []);
  const [existingTemplates, setExistingTemplates] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const initialFormErrors = {
    xmlUrl: '',
    jobName: '',
    cronExpression: '',
    ftpConfig: '',
    host: '',
    username: '',
    password: '',
    filePath: '',
    templateId: '',
  };
  const [formErrors, setFormErrors] = useState({
    xmlUrl: '',
    jobName: '',
    cronExpression: '',
    ftpConfig: '',
    host: '',
    username: '',
    password: '',
    filePath: '',
    templateId: '',
  });

  const updateField = (field, value) => {
    setFtpConfig((prev) => ({ ...prev, [field]: value }));
    setShowBanner(false);
    setFormErrors(initialFormErrors);
    if (ftpConfig) {
      ftpConfig.isSuccess = false;
    }
    // setOpenStep2(false);
  };

  const updateIntegrationField = (field, value) => {
    setIntegrationConfig((prev) => ({ ...prev, [field]: value }));
    setShowBanner(false);
    setFormErrors(initialFormErrors);
    if (ftpConfig) {
      ftpConfig.isSuccess = false;
    }
  };


  const handleJobNameChange = (value) => { setJobName(value); updateIntegrationField('jobName', value); updateField('name', value) };
  const handleTimeZoneChange = (value) => { console.log("formattedNextRun TimeZone changed:", value); setSelectedTimeZone(value); };
  
  // Set default timezone on mount if not already set
  useEffect(() => {
    if (!integrationConfig.timeZone) {
      const defaultTimeZone = timezoneOptions[0]?.value || 'UTC';
      updateIntegrationField('timeZone', defaultTimeZone);
      setSelectedTimeZone(defaultTimeZone);
    }
  }, []);

  // Sync selectedTimeZone state when integrationConfig.timeZone changes
  useEffect(() => {
    if (integrationConfig.timeZone) {
      setSelectedTimeZone(integrationConfig.timeZone);
    }
  }, [integrationConfig.timeZone]);

  useEffect(() => {
    // getTemplates();
    if (action === 'edit' && jobId) {
      getConfigById();

    }

    else {
      if (action === 'create') {

        updateField('name', '');
        updateField('host', '');
        updateField('username', '');
        updateField('password', '');
        updateField('filePath', '');
        const defaultTimeZone = timezoneOptions[0]?.value || 'UTC';
        updateIntegrationField('timeZone', defaultTimeZone);
        handleTimeZoneChange(defaultTimeZone);
        setIntegrationConfig(intialIntegrationForm);
        ftpConfig.isSuccess = false;
      }
      // if (action !== "editExpand" && action !== "createExpand") { getConfig(); }
      // setSelectedFtpConfig(FtpConfigs?.length > 0 ? FtpConfigs[0].id : null);
    }
    // if (importType === 'FTP' && action !== "expand") {
    //   GetFtpConfigs();
    // }

  }, [action, importType]);

  //  useEffect(() => {
  //   console.log("CronSchedulerConfig action or jobId changed=",action,jobId);
  //   if(action === 'delete' && jobId) {
  //     deleteConfigById(jobId);
  //   }
  // }, [action, jobId]);


  const isLessThanOneHour = (cron) => {
    const minutePart = cron.split(' ')[0];
    return minutePart.includes('/') && parseInt(minutePart.split('/')[1]) < 60;
  };


  // const deleteConfigById = async (deleteId) => {

  //       setSchedulerSelectedTab(1);
  //       const response = await fetch(
  //           `${endpoint}/api/Integrations/config-delete?storeUrl=${storeUrl}&jobId=${deleteId}`,
  //           {
  //               method: 'DELETE',
  //           }
  //       );

  //       if (!response.ok) {
  //           throw new Error('Failed to delete XML config');
  //       }
  //       const result = await response.json();
  //       getConfig();
  //       setXmlConfigAction("create");
  //   };

  // function getTemplates() {
  //   getMappedTemplates(storeUrl, importType).then(function (result) {
  //     if (result !== null) {
  //       setExistingTemplates(result);
  //       const existingTemp = [{
  //         id: "0",
  //         name: "Select a Template",
  //         template: "{}"
  //       }];
  //       existingTemp.push(...result);
  //       // setExistingTemplates(result);
  //       setTemplateOptions(existingTemp.map((template) => ({
  //         label: template.name,
  //         value: template?.id?.toString(),
  //       })));
  //     }
  //     else {
  //       // setTempLoading(false);
  //     }
  //   });
  // }

  // const GetFtpConfigs = async () => {

  //   try {
  //     const response = await fetch(`${endpoint}/api/Integrations/ftp-configs-dropdown?storeUrl=${storeUrl}`);
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch FTP configs');
  //     }
  //     const data = await response.json();
  //     setFtpConfigs(data);
  //     setFtpConfigOptions(data.map((config) => ({
  //       label: config.name,
  //       value: config?.id?.toString(),
  //     })));
  //     if (data.length > 0 && action !== 'edit') {
  //       setSelectedFtpConfig(data[0].id);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching FTP configs:', error);
  //   }
  // };

  const getConfigById = async () => {
    const response = await fetch(`${endpoint}/api/Integrations/config-jobid?jobId=${jobId}&storeUrl=${storeUrl}`);
    if (!response.ok) {
      throw new Error('Failed to fetch XML config');
    }
    const data = await response.json();
    setCronExpression(data?.cronExpression);
    setJobName(data?.jobName);
    updateIntegrationField('cronExpression', data?.cronExpression);
    updateIntegrationField('jobName', data?.jobName);
    updateIntegrationField('xmlUrl', data?.feedUrl);
    
    // Set timezone - use the value from backend or fallback to default
    const timeZoneValue = data?.timeZone || timezoneOptions[0]?.value || 'UTC';
    updateIntegrationField('timeZone', timeZoneValue);
    setSelectedTimeZone(timeZoneValue);
    
    setSelectedFtpConfig(data?.ftpConfig?.id?.toString() || null);
    setSelectedTemplateID(data?.templateId?.toString() || null);
    setEditedXmlUrl(data?.xmlUrl);
  }

  const getConfig = async () => {
    try {
      const response = await fetch(`${endpoint}/api/Integrations/config?storeUrl=${storeUrl}&importType=${importType}`);
      if (!response.ok) {
        throw new Error('Failed to fetch XML config');
      }
      const data = await response.json();
      // setCronExpression(data.cronExpression);
      // setJobName(data.jobName);
      setExistingXmlConfig(data);
      // if (action === 'edit') {
      //   setCronExpression(data?.cronExpression);
      //   setJobName(data?.jobName);
      //   setEditedXmlUrl(data?.xmlUrl);
      // }
    } catch (error) {

    }
  };

  const handleSave = async () => {

    setSaveLoading(true);
    try {
      const newErrors = {
        xmlUrl: '',
        jobName: '',
        cronExpression: '',
        // ftpConfig: '',
        templateId: '',
      };

      if (!jobName.trim()) newErrors.jobName = 'Job name is required.';
      if (!cronExpression || !isValidCron(cronExpression)) newErrors.cronExpression = 'Enter a valid cron expression.';
      if (!cronExpression || isLessThanOneHour(cronExpression)) newErrors.cronExpression = 'Minimum allowed interval is 1 hour.';
      //   if (!selectedTemplateID) newErrors.templateId = 'Please select a template.';

      if (importType === 'FTP') {
        // if (!selectedFtpConfig) newErrors.ftpConfig = 'Please select an FTP config.';
      } else {
        const urlToValidate = editedXmlUrl;
        if (!urlToValidate.trim()) newErrors.xmlUrl = 'Please enter a valid  feed URL.';
      }

      const hasError = Object.values(newErrors).some(err => err);
      setFormErrors(newErrors);
      if (hasError) { setSaveLoading(false); return; }
      
      // Ensure timezone is set, with fallback to first timezone option
      const timeZoneToSave = integrationConfig.timeZone || timezoneOptions[0]?.value || 'UTC';
      
      if (importType === "FTP") {
        // const ftpConfig = ftpConfig

        if (!ftpConfig) {
          setSaveLoading(false);
          return;
        }
        else {
          await fetch(`${endpoint}/api/Integrations/add-config?storeUrl=${storeUrl}&importType=${importType}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ feedUrl: urlXml, cronExpression, jobName, jobId, ftpConfig: ftpConfig, timeZone: timeZoneToSave, templateId: selectedTemplateID }),
          });
          setSaveLoading(false);
          // getConfig();
          // setXmlConfigAction("create");
        }
      }
      // else if (cronExpression && xmlUrl.trim() === '' && action !== 'edit' && importType !== "FTP") {
      //   setUrlError('Please enter a valid XML Feed URL before enabling the scheduler.');
      // } 
      else {
        setUrlError('');

        var urlXml = editedXmlUrl;
        if (importType != "FTP") {
          await fetch(`${endpoint}/api/Integrations/add-config?storeUrl=${storeUrl}&importType=${importType}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ feedUrl: urlXml, cronExpression, jobName, jobId, timeZone: timeZoneToSave, templateId: selectedTemplateID }),
          });
        }
        setSaveLoading(false);
        // getConfig();
        // setXmlConfigAction("create");
      }
    }
    catch (error) {

      setSaveLoading(false);
    }
    // setJobId(null);
    // setSchedulerSelectedTab(1);
  };

  const handleTemplateEdit = (templateId) => {
    existingTemplates.forEach((template) => {
      if (template.id === parseInt(templateId)) {
        setRefreshKey(prevKey => prevKey + 1); // Trigger a re-render
        setSelectedTemplate(template);
      }
    });
  };

  const handleTestConnection = async () => {

    setTestLoading(true);
    const newErrors = {
      xmlUrl: '',
      jobName: '',
      cronExpression: '',
      host: '',
      username: '',
      password: '',
      filePath: '',
      templateId: '',
    };

    if (!integrationConfig.jobName.trim()) newErrors.jobName = 'Job name is required.';
    if (!integrationConfig.cronExpression || !isValidCron(integrationConfig.cronExpression)) newErrors.cronExpression = 'Enter a valid cron expression.';
    if (!integrationConfig.cronExpression || isLessThanOneHour(integrationConfig.cronExpression)) newErrors.cronExpression = 'Minimum allowed interval is 1 hour.';
    if (importType === 'FTP' && ftpConfig) {
      if (!ftpConfig.host) newErrors.host = 'Host is required.';
      if (!ftpConfig.username) newErrors.username = 'Username is required.';
      if (!ftpConfig.password) newErrors.password = 'Password is required.';
      if (!ftpConfig.filePath) newErrors.filePath = 'Directory and filename is required.';
    }

    setFormErrors(newErrors);
    if (importType === 'FTP') {
      try {
        const hasError = Object.values(newErrors).some(err => err);
        if (!hasError) {
          setTestLoading(true);
          const res = await axios.post(`${endpoint}/api/Integrations/test-ftp`, ftpConfig);
          setFTPConnection(res?.data);
          setShowBanner(true);
          setTestLoading(false);
          
          // Check if both connection and file are successful
          if (res?.data?.connectionSuccess && res?.data?.fileFound) {
            if (ftpConfig) ftpConfig.isSuccess = true;
            setCompletedSteps({
              step1: true,
              step2: false
            });
          }
          else {
            if (ftpConfig) ftpConfig.isSuccess = false;
            setCompletedSteps({
              step1: false,
              step2: false,
            });
          }
        }
        setTestLoading(false);
      } catch (err) {

        if (ftpConfig) ftpConfig.isSuccess = false;
        setFTPConnection(err?.response?.data || {
          connectionSuccess: false,
          fileFound: false,
          message: 'Unexpected error occurred while testing FTP connection.'
        });
        setTestLoading(false);
        setShowBanner(true);
        setCompletedSteps({
          step1: false,
          step2: false,
        });
      }
    }
    else {
      try {
        const hasError = Object.values(newErrors).some(err => err);
        if (!hasError) {
          setTestLoading(true);
          //       public string StoreUrl { get; set; }
          //     public string ImportType { get; set; }
          //     public string Url { get; set; }
          //     public FTPConfig FtpConfig { get; set; }
          // }
          const format = {
            StoreUrl: storeUrl,
            ImportType: importType,
            Url: integrationConfig.xmlUrl,
            FtpConfig: null,
          };
          const res = await axios.post(`${endpoint}/api/Integrations/test-http`, format);

          setHttpConnection(res?.data);
          setShowBanner(true);
          setTestLoading(false);
          if (res?.data?.success) {
            setCompletedSteps({
              step1: true,
              step2: false
            });

          }
        }
        setTestLoading(false);
      } catch (err) {

        setCompletedSteps({
          step1: false,
          step2: false,
        });
        setHttpConnection(err?.response?.data || {
          success: false,
          error: 'Unexpected error occurred while testing HTTP connection.'
        });
        setTestLoading(false);
        setShowBanner(true);
      }
    }
  };

  const saveCronPreset = () => {
    setIntegrationConfig((prev) => ({ ...prev, cronExpression: cronPreset }));
  }

  // Edit Schedule Modal with Portal rendering and z-index styling
  const editScheduleModal = (
    <>
      <style>
        {`
          #${modalId}::part(overlay) {
            z-index: 10000 !important;
          }
          #${modalId}::part(dialog) {
            z-index: 10001 !important;
          }
        `}
      </style>
      <s-modal id={modalId} heading="Edit Schedule" size="small">
        <s-stack gap="base">
          <s-select
            key={`timezone-${integrationConfig.timeZone || 'default'}`}
            label="Time Zone"
            value={integrationConfig.timeZone || timezoneOptions[0]?.value || 'UTC'}
            onChange={(e) => { updateIntegrationField('timeZone', e.target.value); handleTimeZoneChange(e.target.value); }}
          >
            {timezoneOptions.map((tz) => (
              <s-option key={tz.value} value={tz.value}>{tz.label}</s-option>
            ))}
          </s-select>
          
          <s-select
            label="Choose schedule"
            value={selectedSchedule}
            onChange={(e) => setSelectedSchedule(e.target.value)}
          >
            <s-option value="">Select a schedule</s-option>
            {scheduleOptions.map((opt) => (
              <s-option key={opt.value} value={opt.value}>{opt.label}</s-option>
            ))}
          </s-select>

          <s-grid gridTemplateColumns="repeat(2, 1fr)" gap="base">
            <s-grid-item>
              <s-select
                label="Hour"
                value={selectedHour}
                onChange={(e) => setSelectedHour(e.target.value)}
              >
                {hours.map((h) => (
                  <s-option key={h} value={h}>{h}</s-option>
                ))}
              </s-select>
            </s-grid-item>
            
            <s-grid-item>
              <s-select
                label="Minute"
                value={selectedMinute}
                onChange={(e) => setSelectedMinute(e.target.value)}
              >
                {minutes.map((m) => (
                  <s-option key={m} value={m}>{m}</s-option>
                ))}
              </s-select>
            </s-grid-item>
          </s-grid>
          
          {((cronPreset && isValidCron(cronPreset)) && (selectedHour || selectedMinute)) ? (
            <s-text tone="subdued">
              This will run: {cronstrue.toString(cronPreset, { verbose: true })}
            </s-text>
          ) : (
            <s-text tone="subdued">
              Not sure how to write a cron expression?{' '}
              <s-link url="https://crontab.guru" target="_blank">
                Use crontab.guru
              </s-link>
            </s-text>
          )}
        </s-stack>
        
        <s-button 
          slot="primary-action"
          variant="primary" 
          onClick={() => { saveCronPreset(); togglePopover(); }}
        >
          Set
        </s-button>
      </s-modal>
    </>
  );

  return (
    <>
      <s-stack gap="large">
      {importType !== 'FTP' && (
        <s-text-field
          label="Feed URL"
          value={integrationConfig.xmlUrl}
          onChange={(e) => { updateIntegrationField('xmlUrl', e.target.value); }}
          placeholder={importType === "XML" ? "e.g., https://example.com/feed.xml" : "e.g., https://example.com/feed.xlsx"}
          helpText="This URL will be used to fetch data."
          error={formErrors.xmlUrl || undefined}
        />
      )}

      {importType === 'FTP' && (
        <>
          <s-stack direction="horizontal" gap="base">
            <s-text-field
              label="Host"
              value={ftpConfig.host}
              onChange={(e) => {
                updateField('host', e.target.value);
                setErrorHost(false);
              }}
              error={formErrors.host || (errorHost ? 'Host is required.' : undefined)}
              helpText="e.g. ftp.example.com or 192.168.1.20"
            />
            <s-text-field
              label="Username"
              value={ftpConfig.username}
              onChange={(e) => updateField('username', e.target.value)}
              autoComplete="off"
              error={formErrors.username ? 'Username is required.' : undefined}
            />
          </s-stack>
          
          <s-stack direction="horizontal" gap="base">
            <s-password-field
              label="Password"
              value={ftpConfig.password}
              onChange={(e) => updateField('password', e.target.value)}
              error={formErrors.password ? 'Password is required.' : undefined}
              autoComplete="off"
            />
            <s-text-field
              label="Directory and filename"
              value={ftpConfig.filePath}
              onChange={(e) => updateField('filePath', e.target.value)}
              error={formErrors.filePath ? 'Directory and filename is required.' : undefined}
              helpText="e.g. /catalog.xlsx"
            />
          </s-stack>
        </>
      )}

      <s-grid gridTemplateColumns="repeat(2, 1fr)" gap="base">
        <s-grid-item>
          <s-text-field
            label="Job Name"
            value={integrationConfig.jobName}
            onChange={(e) => handleJobNameChange(e.target.value)}
            placeholder="e.g., daily-scheduler"
            helpText="This name will be used to identify the scheduled job."
            error={formErrors.jobName || undefined}
          />
        </s-grid-item>
        
        <s-grid-item>
            <s-text-field
              label="Cron Expression"
              value={integrationConfig.cronExpression}
              onChange={(e) => handleCronChange(e.target.value)}
              disabled={true}
              error={formErrors.cronExpression && !isValidCron(formErrors.cronExpression) ? "Invalid cron expression." : undefined}
              placeholder="e.g., 0 0 * * *"
            />
            <s-stack direction="inline" gap="large-100">
          {integrationConfig.cronExpression && isValidCron(integrationConfig.cronExpression) ? (
            <s-text color="subdued">
              This will run: {cronstrue.toString(integrationConfig.cronExpression, { verbose: true })}
            </s-text>
          ) : (
            <s-text color="subdued">
              Not sure how to write a cron expression?{' '}
              <s-link url="https://crontab.guru" target="_blank">
                Use crontab.guru
              </s-link>
            </s-text>
            
          )}
          <s-box style={{ position: 'absolute', top: '0', right: '0' }}>
              <s-link onClick={() => { parseCronExpression(integrationConfig.cronExpression); togglePopover(); }}>Edit</s-link>
            </s-box>
            </s-stack>
        </s-grid-item>
      </s-grid>

      <s-stack direction="horizontal" gap="base" alignment="start">
        <s-button 
          onClick={handleTestConnection} 
          disabled={!integrationConfig.cronExpression || !isValidCron(integrationConfig.cronExpression) || isLessThanOneHour(integrationConfig.cronExpression)} 
          variant='primary' 
          size="large" 
          loading={testLoading}
        >
          Test Connection
        </s-button>
      </s-stack>

      {showBanner && ftpConnection && importType === 'FTP' && (
        <s-banner
          tone={ftpConnection.connectionSuccess && ftpConnection.fileFound ? 'success' : ftpConnection.connectionSuccess ? 'warning' : 'critical'}
          onDismiss={() => setShowBanner(false)}
        >
          {ftpConnection.message || 'Connection test completed'}
        </s-banner>
      )}

      {showBanner && httpConnection && importType !== 'FTP' && (
        <s-banner
          tone={httpConnection.success ? 'success' : 'critical'}
          onDismiss={() => setShowBanner(false)}
        >
          {httpConnection?.success
            ? httpConnection?.message
            : httpConnection?.error
              ? 'Connection refused - ' + httpConnection?.error
              : 'Connection failed'}
        </s-banner>
      )}
      
      {selectedTemplate && (
        <div style={{ display: 'none' }}>
          <Presets connectionType={importType} template={selectedTemplate} refreshKey={refreshKey} />
        </div>
      )}
    </s-stack>
    
    {/* Render modal via Portal at document.body level */}
    {ReactDOM.createPortal(editScheduleModal, document.body)}
    </>
  );

  function cronValidation(cronExpression) {
    var validCOrn = isValidCron(cronExpression);
    var isOneHour = isLessThanOneHour(cronExpression);
    if (!validCOrn) {
      formErrors.cronExpression = 'Enter a valid cron expression.';
    }
    if (isOneHour) {
      formErrors.cronExpression = 'Minimum allowed interval is 1 hour.';
    }
  }

  function isValidCron(expression) {
    const parts = expression.trim().split(/\s+/);
    if (parts.length < 5 || parts.length > 6) return false;
    const fieldRegex = {
      seconds: /^(\*|([0-5]?\d)(-([0-5]?\d))?(\/\d+)?)(,(\*|([0-5]?\d)(-([0-5]?\d))?(\/\d+)?))*$/,
      minutes: /^(\*|([0-5]?\d)(-([0-5]?\d))?(\/\d+)?)(,(\*|([0-5]?\d)(-([0-5]?\d))?(\/\d+)?))*$/,
      hours: /^(\*|([01]?\d|2[0-3])(-([01]?\d|2[0-3]))?(\/\d+)?)(,(\*|([01]?\d|2[0-3])(-([01]?\d|2[0-3]))?(\/\d+)?))*$/,
      dayOfMonth: /^(\*|([1-9]|[12]\d|3[01])(-([1-9]|[12]\d|3[01]))?(\/\d+)?|\?|L|LW|[1-9]W)(,(\*|([1-9]|[12]\d|3[01])(-([1-9]|[12]\d|3[01]))?(\/\d+)?|\?|L|LW|[1-9]W))*$/,
      month: /^(\*|(1[0-2]|0?[1-9])(-(1[0-2]|0?[1-9]))?(\/\d+)?|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)(,(\*|(1[0-2]|0?[1-9])(-(1[0-2]|0?[1-9]))?(\/\d+)?|JAN|FEB|...))*$/i,
      dayOfWeek: /^(\*|[0-7](-[0-7])?(\/\d+)?|SUN|MON|TUE|WED|THU|FRI|SAT|L)(,(\*|[0-7](-[0-7])?(\/\d+)?|SUN|MON|TUE|WED|THU|FRI|SAT|L))*$/i,
    };

    const fieldNames = parts.length === 6
      ? ["seconds", "minutes", "hours", "dayOfMonth", "month", "dayOfWeek"]
      : ["minutes", "hours", "dayOfMonth", "month", "dayOfWeek"];

    return parts.every((part, idx) =>
      fieldRegex[fieldNames[idx]].test(part)
    );
  }
}
